import styled from 'styled-components';
import { Container } from '../styled/containers';

export const Wrapper = styled(Container)`
  margin-bottom: ${({ theme }) => theme.spacing.large};
  overflow-wrap: normal;
  overflow-x: auto;
`;

export const Td = styled.td`
  padding: ${({ theme }) => theme.spacing.standard};
  vertical-align: top;
  border-collapse: collapse;
  border: 1px solid ${({ theme }) => theme.palette.border};
  background-color: ${({ theme }) => theme.palette.white};
  min-width: 88px;
`;

export const Th = styled(Td)`
  background-color: ${({ theme }) => theme.palette.lightBackground};
`;
